import React from "react";

export default function History_TheoryOfMind() {
  return (
    <div>
      <h1>History_TheoryOfMind</h1>
      <p>This is the History_TheoryOfMind component.</p>
    </div>
  );
}
